// pages/auth-register.page.tsx
import { Loader2 } from 'lucide-react'
import { Button } from '@/modules/shared/components/ui/button'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/modules/shared/components/ui/form'
import { Input } from '@/modules/shared/components/ui/input'
import { InputPassword } from '@/modules/shared/components/ui/input-password'
import { AuthLayoutComponent } from '../components/auth-layout.component'
import { useAuthRegister } from '../hooks/use-auth-register.hook'

export function AuthRegisterPage() {
	const { form, isLoading, error, submitAuthRegister } = useAuthRegister()

	return (
		<AuthLayoutComponent
			titleAuth="Cadastrar usuário"
			navigation="Já tem uma conta? Acessar"
			route="/login"
		>
			<Form {...form}>
				<form
					onSubmit={form.handleSubmit(submitAuthRegister)}
					className="space-y-4 sm:space-y-5"
				>
					{/* Código de Acesso - Full width */}
					<FormField
						control={form.control}
						name="accessCode"
						render={({ field }) => (
							<FormItem>
								<FormLabel className="text-sm font-medium text-gray-700 dark:text-gray-300">
									Código de Acesso
								</FormLabel>
								<FormControl>
									<Input
										placeholder="Digite o código de acesso"
										className="text-base"
										{...field}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>

					{/* Nome e Sobrenome - Grid em desktop, stack em mobile */}
					<div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-4">
						<FormField
							control={form.control}
							name="name"
							render={({ field }) => (
								<FormItem>
									<FormLabel className="text-sm font-medium text-gray-700 dark:text-gray-300">
										Nome
									</FormLabel>
									<FormControl>
										<Input
											placeholder="Digite seu nome"
											className="text-base"
											{...field}
										/>
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>

						<FormField
							control={form.control}
							name="lastName"
							render={({ field }) => (
								<FormItem>
									<FormLabel className="text-sm font-medium text-gray-700 dark:text-gray-300">
										Sobrenome
									</FormLabel>
									<FormControl>
										<Input
											placeholder="Digite seu sobrenome"
											className="text-base"
											{...field}
										/>
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>
					</div>

					{/* E-mail - Full width */}
					<FormField
						control={form.control}
						name="email"
						render={({ field }) => (
							<FormItem>
								<FormLabel className="text-sm font-medium text-gray-700 dark:text-gray-300">
									E-mail
								</FormLabel>
								<FormControl>
									<Input
										type="email"
										placeholder="Digite seu e-mail"
										className="text-base"
										{...field}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>

					{/* Senhas - Grid em desktop, stack em mobile */}
					<div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-4">
						<FormField
							control={form.control}
							name="password"
							render={({ field }) => (
								<FormItem>
									<FormLabel className="text-sm font-medium text-gray-700 dark:text-gray-300">
										Senha
									</FormLabel>
									<FormControl>
										<InputPassword
											autoCapitalize="none"
											autoComplete="new-password"
											placeholder="Digite sua senha"
											className="text-base"
											{...field}
										/>
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>

						<FormField
							control={form.control}
							name="confirmPassword"
							render={({ field }) => (
								<FormItem>
									<FormLabel className="text-sm font-medium text-gray-700 dark:text-gray-300">
										Confirmar senha
									</FormLabel>
									<FormControl>
										<InputPassword
											autoCapitalize="none"
											autoComplete="new-password"
											placeholder="Confirme sua senha"
											className="text-base"
											{...field}
										/>
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>
					</div>

					{/* Error message */}
					{error && (
						<div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3">
							<p className="text-sm text-red-600 dark:text-red-400 text-center">
								Erro ao cadastrar usuário. Verifique os dados e tente novamente.
							</p>
						</div>
					)}

					{/* Submit button */}
					<div className="pt-4">
						<Button
							className="w-full h-12 text-base font-medium bg-red-700 hover:bg-red-800 transition-all duration-200"
							type="submit"
							disabled={isLoading}
						>
							{isLoading && <Loader2 size={20} className="mr-2 animate-spin" />}
							Cadastrar
						</Button>
					</div>
				</form>
			</Form>
		</AuthLayoutComponent>
	)
}

